import messages from "../messages/messages.js";
import {useEffect, useState} from "preact/hooks";
import {ChevronUpIcon, LockClosedIcon} from "@heroicons/react/24/solid";


export function PaymentMethods({ class: customClass = "" }) {
    useEffect(() => {
    }, []);

    return (
        <section
            aria-label="Secure checkout"
            className={`bg-zinc-800 p-4 sm:p-6 mx-auto w-full md:w-max max-w-lg rounded-lg shadow-lg ${customClass}`}
        >
            <div className="flex flex-col gap-4 flex-row items-center justify-between">
                <div className="flex items-center gap-3">
                    <LockClosedIcon className="h-6 w-6" />
                    <div className="text-base sm:text-lg font-semibold">
                        Secure Checkout
                    </div>
                </div>

                <a
                    href="https://stripe.com/docs/security"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Learn more about Stripe security"
                >
                    <img
                        src="/img/payment-methods/stripe-badge.svg"
                        alt="Powered by Stripe"
                        className="h-6 md:h-8 w-auto"
                        loading="lazy"
                    />
                </a>
            </div>

            {/* Payment logos (yours) */}
            <div className="mt-4 flex flex-wrap items-center gap-1 md:gap-3 justify-around">
                <img className="size-10 h-auto" src="/img/payment-methods/visa.png" alt="Visa" title="Visa"
                     loading="lazy"/>
                <img className="size-10 h-auto" src="/img/payment-methods/mastercard.png" alt="Mastercard"
                     title="Mastercard" loading="lazy"/>
                <img className="size-10 h-auto" src="/img/payment-methods/amex.png" alt="American Express"
                     title="American Express" loading="lazy"/>
                <img className="size-10 h-auto" src="/img/payment-methods/apple-pay.png" alt="Apple Pay"
                     title="Apple Pay" loading="lazy"/>
                <img className="size-10 h-auto" src="/img/payment-methods/google-pay.png" alt="Google Pay"
                     title="Google Pay" loading="lazy"/>
                <img className="size-10 h-auto" src="/img/payment-methods/paypal.png" alt="PayPal" title="PayPal"
                     loading="lazy"/>
            </div>
        </section>
    );
}
